export const WALLET_TYPES = [
  { value: "trading", label: "Trading" },
  { value: "carret24", label: "Carret24" },
  { value: "private_client", label: "Private Client" },
];

export const normalizeBalancesResponse = (data, walletType = "trading") => ({
  account_id: data.account_id,
  email: data.account_email,
  is_frozen: data.is_frozen,
  is_debit_frozen: data.is_debit_frozen,
  is_lien_marked: data.is_lien_marked,
  total_inr_value: data.total_portfolio_inr_value,
  raw: data,
  assets: (data.balances?.[walletType] || []).map((wallet) => ({
    wallet_id: wallet.wallet_id,
    wallet_type: walletType,
    asset: wallet.asset,
    total_balance: wallet.total_balance,
    blocked_balance: wallet.locked_balance,
    available_balance: wallet.current_balance,
    inr_equivalent: wallet.inr_equivalent,
    conversion_rate: wallet.inr_price,
  })),
});

export const getAccountStatuses = (data) => {
  if (!data) return [];
  const statuses = [];

  if (data.is_account_closed) statuses.push({ label: "Account Closed", color: "red" });
  if (data.is_frozen) statuses.push({ label: "Blocked / Frozen", color: "red" });
  if (data.is_debit_frozen) statuses.push({ label: "Debit Freeze", color: "blue" });
  if (data.is_lien_marked) statuses.push({ label: "Lien Marked", color: "orange" });

  if (statuses.length === 0) {
    statuses.push({ label: "Active", color: "green" });
  }

  return statuses;
};

export const getAccountStatusLabel = (data) => {
  const statuses = getAccountStatuses(data);
  return statuses.map((s) => s.label).join(" | ");
};

export const getAccountStatusColor = (data) => {
  const statuses = getAccountStatuses(data);
  if (statuses.length === 0 || statuses[0].label === "Active") return "green";
  return statuses[0].color; // Return first status color for single-tag fallback
};
